import React from 'react';
import { DatePicker } from 'shards-react';
import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import PropTypes from 'prop-types';
import { formatDateOnly, parseDateOnly } from '../../../utils/dateOnly';
registerLocale('es', es);

class GenericInputDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: parseDateOnly(props.value)
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ date: parseDateOnly(this.props.value) });
    }
  }

  handleChange = (date) => {
    this.setState({ date: date });
    this.props.handleInputChange(formatDateOnly(date));
  };

  render() {
    const { inputName, placeHolder } = this.props;
    return (
      <DatePicker
        dateFormat="yyyy-MM-dd"
        locale="es"
        name={inputName}
        onChange={this.handleChange}
        placeholderText={placeHolder}
        selected={this.state.date}
        todayButton={'Hoy'}
      />
    );
  }
}

GenericInputDate.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired,
  placeHolder: PropTypes.string,
  value: PropTypes.string
};

export default GenericInputDate;
